import type { IOption } from "@Front/Components/DesignSystem/Dropdown/DropdownMenu/DropdownOption";
import type { IAddThirdPartyRequest } from "@Front/Api/LeCoffreApi/Notary/FolderThirdParties/FolderThirdParties";

/**
 * Liste ordonnée unique des types de tiers (alignée sur Prisma `EThirdPartyRole` et l’API notaire).
 * Tous les libellés UI et options de formulaire en dérivent.
 */
export const THIRD_PARTY_ROLES_ORDERED = [
	{ id: "COURTIER", label: "Courtier" },
	{ id: "AGENT_IMMOBILIER", label: "Agent Immobilier" },
	{ id: "AVOCAT", label: "Avocat" },
	{ id: "BANQUE", label: "Banque" },
	{ id: "TUTELLE", label: "Tutelle" },
	{ id: "SYNDIC", label: "Syndic" },
	{ id: "EXPERT", label: "Expert" },
	{ id: "GENEALOGISTE", label: "Généalogiste" },
	{ id: "AUTRE", label: "Autre" },
] as const;

export type ThirdPartyRoleId = (typeof THIRD_PARTY_ROLES_ORDERED)[number]["id"];

export type ThirdPartyRoleOption = IOption & { id: IAddThirdPartyRequest["role_type"] };

export const THIRD_PARTY_ROLE_OPTIONS: ThirdPartyRoleOption[] = THIRD_PARTY_ROLES_ORDERED.map((r) => ({
	id: r.id,
	label: r.label,
}));

export const DEFAULT_THIRD_PARTY_ROLE_OPTION: ThirdPartyRoleOption =
	THIRD_PARTY_ROLE_OPTIONS[0] ?? { id: "AUTRE", label: "Autre" };

const labelEntries = THIRD_PARTY_ROLES_ORDERED.map((r) => [r.id, r.label] as const);

export const THIRD_PARTY_ROLE_TYPE_LABELS = Object.fromEntries(labelEntries) as {
	readonly [K in ThirdPartyRoleId]: string;
};

export function getThirdPartyRoleLabel(roleType: string): string {
	const key = roleType as ThirdPartyRoleId;
	const fromMap = THIRD_PARTY_ROLE_TYPE_LABELS[key];
	return fromMap ?? roleType;
}
